import React, { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { InstagramOutlined, TikTokOutlined } from "@ant-design/icons";
import { Button, Space, Typography } from "antd";

import { compareWithJSON, openNewTab } from "utils/helper";
import { useLivestreamSelector } from "hooks/useSelector";

const { Text } = Typography;

const LivestreamAlert = () => {
  const { t } = useTranslation();

  const livestream = useLivestreamSelector();

  const handleTiktok = useCallback(() => {
    openNewTab(livestream?.tiktok_url, false);
  }, [livestream?.tiktok_url]);

  const handleInstagram = useCallback(() => {
    openNewTab(livestream?.instagram_url, false);
  }, [livestream?.instagram_url]);

  return (
    <div
      style={{
        position: "relative",
        top: 0,
        width: "100%",
        height: 45,
        zIndex: 50,
        backgroundColor: "#FFBE3D",
        display: "flex",
        placeItems: "center",
        justifyContent: "center",
      }}
    >
      <Space size={30}>
        <Space>
          <span role="img" aria-label="">
            🔴
          </span>
          <Text style={{ color: "#000000" }}>
            {" "}
            {t("livestream.direct_consultation_with_gajihub_amazing_team")}
          </Text>
        </Space>
        <Space size={0}>
          <Button
            onClick={handleTiktok}
            icon={<TikTokOutlined style={{ color: "#000000" }} />}
            type="text"
          >
            <Text
              style={{ textDecoration: "underline", color: "#000000" }}
              className="hover:opacity-75"
            >
              Live Tiktok
            </Text>
          </Button>
          <Button
            onClick={handleInstagram}
            icon={<InstagramOutlined style={{ color: "#000000" }} />}
            type="text"
          >
            <Text
              style={{ textDecoration: "underline", color: "#000000" }}
              className="hover:opacity-75"
            >
              Live Instagram
            </Text>
          </Button>
        </Space>
      </Space>
    </div>
  );
};

export default memo(LivestreamAlert, compareWithJSON);
